export * from '@material-ui/core/styles';
//# sourceMappingURL=index.js.map